/** @format */

import {UploadArtworkModal} from './upload_artwork_modal';
import {PROOF_STATUS_PENDING} from 'frontier-constants';
import {ORDER_STATUS_WAITING_ON_CUSTOMER, ORDER_STATUS_PREPRINTING_CUE} from 'frontier-constants';
import NumberFormat from 'react-number-format';
import {Table} from '@sttark/design-system';
import {If} from 'frontier-utilities';
import {Design} from './design';
import React from 'react';

// styles
import './order_artwork.scss';

export const OrderArtwork = props => {
    const {order, designsOrders} = props;

    const isWaitingOnCustomer = order.status_id === ORDER_STATUS_WAITING_ON_CUSTOMER;
    const isInPrintingCue = order.status_id === ORDER_STATUS_PREPRINTING_CUE;

    const canReplaceArtwork =
        (isWaitingOnCustomer || isInPrintingCue) &&
        (order.latest_proof?.status === PROOF_STATUS_PENDING || !order.latest_proof) &&
        !order.is_reorder;

    return (
        <Table
            columns={[
                {
                    title: 'Artwork',
                    index: 'artwork',
                    key: 'artwork'
                },
                {
                    title: 'Design ID',
                    index: 'design_id',
                    key: 'design_id'
                },
                {
                    title: 'Quantity',
                    index: 'quantity',
                    key: 'quantity'
                },
                {
                    title: '',
                    index: 'actions',
                    key: 'actions'
                }
            ]}
            rows={designsOrders.map(design => {
                return {
                    artwork: (
                        <div key={design.id}>
                            <Design designsOrders={designsOrders} design={design} order={order} />
                            <If condition={canReplaceArtwork}>
                                <UploadArtworkModal order={order} designsOrders={designsOrders} />
                            </If>
                        </div>
                    ),
                    design_id: (
                        <p className="order-view-artwork-44th__id m-0">{design.design_id}</p>
                    ),
                    quantity: (
                        <NumberFormat
                            className="order-view-artwork-44th__qty m-0"
                            thousandSeparator={true}
                            value={design.qty}
                            displayType="text"
                        />
                    ),
                    actions: (
                        <div>
                            <div className="color-accent-primary d-flex align-items-center justify-content-start gap-1">
                                <i className="fa fa-save" />
                                <a
                                    className="m-0 p-0"
                                    href={`/account/designs/download-design?key=${encodeURIComponent(
                                        design.s3key
                                    )}&bucket=${[process.env.FILESTACK_ARTWORK_CONTAINER]}`}
                                    target="_blank">
                                    <u>Download Original</u>
                                </a>
                            </div>
                            {design.design.pressready_key && (
                                <div className="color-accent-primary d-flex align-items-center justify-content-start gap-1">
                                    <i className="fa fa-save" />
                                    <a
                                        className="m-0 p-0"
                                        href={`/account/designs/download-design?key=${encodeURIComponent(
                                            design.design.pressready_key
                                        )}&bucket=${[process.env.FILESTACK_ARTWORK_CONTAINER]}`}
                                        target="_blank">
                                        <u>Download Press-Ready</u>
                                    </a>
                                </div>
                            )}
                        </div>
                    ),
                    key: design.id
                };
            })}
            className="order-view-artwork-44th"
        />
    );
};
